/**
 * 🛠️ SERVICE: Taxonomy Reconstructor (The Single Pot)
 * Location: src/registered/site-admin/components/Workflow-esg/services/taxonomy_reconstructor.js
 */
import extractPresentation from "../presentationExtractor";
import extractDimensions from "../definitionExtractor";
import extractCalculations from "../calculationExtractor";
import buildSchema from "../schemaBuilder";

export const TaxonomyReconstructor = {
    reconstruct: (presData, defData, calcData) => {
        // 1. EXTRACT: Create the base ingredients
        const presentation = extractPresentation(presData.rows, presData.colMap);
        const dimensions   = extractDimensions(defData.rows, defData.colMap);
        const calculations = extractCalculations(calcData.rows, calcData.colMap);

        // 2. THE JOIN: This is the sandbox logic moving into React
        // buildSchema creates the 'finance_logic' block and recursive nesting
        const esgTree = buildSchema(presentation, dimensions, calculations);
        const concepts = esgTree.concepts || {};

        // 3. AUDIT PROOF: Building the search index for the Trawler
        const searchIndex = Object.keys(concepts).map(key => {
            const concept = concepts[key];
            const rawRole = concept.role || ""; 
            const match = rawRole.match(/^\[(\d+)\]\s+([^.]+)\.([^ ]+)\s+(.*)$/);
            
            return {
                id: key,
                level: concept.level || "N/A",
                cluster: match ? match[1] : "", 
                standard: match ? match[2] : "", 
                legalRef: match ? match[3] : "", 
                label: match ? match[4] : (concept.label || key),
                isCalculated: !!concept.finance_logic, // PROOF: math was joined
                searchString: `${concept.level} ${rawRole} ${concept.label} ${key}`.toLowerCase()
            };
        });

        // 4. RETURN: Integrated Payload for Workflow_Hub
        return { 
            esgTree, 
            xbrlRelationships: {
                presentation: esgTree.roots || [],
                definition: dimensions || [],
                calculation: Object.keys(calculations), 
                searchIndex, 
                stats: {
                    totalConcepts: Object.keys(concepts).length,
                    dimensionPairs: dimensions?.length || 0,
                    calculationRules: Object.keys(calculations).length 
                }
            }
        };
    }
};